import { Icon, IconProps } from "../Icon";

const Maximize = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 2V4H26.59L17 13.58L18.41 15L28 5.41V11H30V2H21ZM15 18.42L13.59 17L4 26.59V21H2V30H11V28H5.41L15 18.42Z"
      fill="currentColor"
    />
  </Icon>
);

export default Maximize;
